import React from "react";
import LegalLayout from "../components/LegalLayout";

const COMPANY = {
  name: "Bottega di Nalise",
  vat: "03399260128",
  address: "Via Sabotino 32, 21049 Tradate (VA) — Italy",
  email: "info@nalise.it",
  phone: "+39 392 4735682",
};

const Section = ({ title, children }) => (
  <section className="space-y-3">
    <h2 className="font-display font-bold text-2xl text-slate-900">{title}</h2>
    {children}
  </section>
);

const TermsPage = () => (
  <LegalLayout title="Termini e Condizioni" lastUpdate="Febbraio 2026">
    <p>
      Le presenti Condizioni Generali di Vendita disciplinano la vendita di prodotti
      effettuata a distanza tramite il sito {COMPANY.name} ({COMPANY.vat}) e si applicano
      a tutti gli ordini effettuati dai clienti.
    </p>

    <Section title="1. Informazioni sul venditore">
      <p>
        Venditore: <strong>{COMPANY.name}</strong><br />
        Sede: {COMPANY.address}<br />
        P.IVA: {COMPANY.vat}<br />
        Email: <a href={`mailto:${COMPANY.email}`} className="text-sky-600 underline">{COMPANY.email}</a><br />
        Telefono: {COMPANY.phone}
      </p>
    </Section>

    <Section title="2. Oggetto del contratto">
      <p>
        Con il presente contratto il venditore vende e il cliente acquista a distanza,
        tramite mezzi telematici, i giochi da tavolo e i prodotti correlati indicati e
        offerti in vendita sul sito.
      </p>
    </Section>

    <Section title="3. Conclusione del contratto">
      <p>
        Il contratto si conclude con l'invio dell'ordine da parte del cliente e la relativa
        accettazione da parte del venditore, comunicata via email all'indirizzo fornito dal
        cliente. Il cliente riceverà conferma dell'ordine con un riepilogo dei prodotti
        acquistati, del prezzo totale e dei costi di spedizione.
      </p>
    </Section>

    <Section title="4. Prezzi e pagamento">
      <p>
        I prezzi indicati sul sito sono comprensivi di IVA. I metodi di pagamento accettati
        sono: PayPal e gli altri metodi configurati al checkout. Il pagamento avviene in
        modalità sicura tramite la piattaforma WooCommerce / PayPal.
      </p>
    </Section>

    <Section title="5. Spedizione e consegna">
      <p>
        Le spedizioni vengono effettuate in Italia e nei paesi indicati al checkout entro
        24-48h dalla conferma del pagamento. Costi e tempi di consegna sono specificati al
        momento dell'ordine. Per dettagli completi consulta la pagina{" "}
        <a href="/spedizioni-e-resi" className="text-sky-600 underline">Spedizioni e Resi</a>.
      </p>
    </Section>

    <Section title="6. Diritto di recesso">
      <p>
        Ai sensi del D.Lgs. 206/2005 e successive modifiche, il consumatore ha diritto di
        recedere dal contratto entro 14 giorni dalla ricezione del prodotto, senza dover
        fornire alcuna motivazione. Per esercitare il diritto di recesso è sufficiente
        inviare comunicazione scritta a {COMPANY.email} prima della scadenza dei 14 giorni.
        I prodotti devono essere restituiti integri, nella confezione originale e completi
        di ogni componente. Le spese di restituzione sono a carico del cliente.
      </p>
    </Section>

    <Section title="7. Garanzia legale di conformità">
      <p>
        Tutti i prodotti venduti sono coperti dalla garanzia legale di conformità di 24
        mesi prevista dal Codice del Consumo. In caso di difetti di conformità, il cliente
        ha diritto al ripristino della conformità del bene tramite riparazione o
        sostituzione, oppure a una congrua riduzione del prezzo o alla risoluzione del
        contratto.
      </p>
    </Section>

    <Section title="8. Reclami e risoluzione delle controversie">
      <p>
        Per qualsiasi reclamo il cliente può scrivere a {COMPANY.email}. Per la risoluzione
        di eventuali controversie può inoltre utilizzare la piattaforma europea ODR
        all'indirizzo{" "}
        <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-sky-600 underline">
          ec.europa.eu/consumers/odr
        </a>.
      </p>
    </Section>

    <Section title="9. Legge applicabile e foro competente">
      <p>
        Il presente contratto è regolato dalla legge italiana. Per ogni controversia è
        competente il Foro del luogo di residenza o domicilio del consumatore, se ubicato
        in Italia.
      </p>
    </Section>

    <Section title="10. Modifiche">
      <p>
        Il venditore si riserva il diritto di modificare in qualsiasi momento le presenti
        Condizioni Generali di Vendita. Le modifiche saranno efficaci dal momento della
        pubblicazione sul sito.
      </p>
    </Section>

    <p className="text-sm text-slate-500 pt-6 border-t">
      Documento di esempio non legalmente vincolante. Si consiglia di farlo rivedere dal
      proprio consulente legale prima della pubblicazione definitiva.
    </p>
  </LegalLayout>
);

export default TermsPage;
